import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { User } from '../../types/User'
import Navbar, { UserMenu } from '../Navbar/Navbar'
import { authContext } from '../CognitoContextProvider/CognitoContextProvider'

const Header = ({ user }: { user: User }): JSX.Element => {
  const { auth, logOut } = useContext(authContext)

  return (
    <nav className="global-header">
      <div className="global-header__inner">
        <div className="global-header__brand-group">
          <Link className="no-decoration global-header__brand" to={'/time-off'}>
            <img
              src="/images/matrixmanaged-header.png"
              alt="Matrix Managed"
              className="global-header__logo"
            />
          </Link>
          <Navbar
            isAdmin={user.isAdmin}
            isGrowthWheelReviewer={user.isGrowthWheelReviewer}
            isGrowthWheelEditor={user.isGrowthWheelEditor}
          />
        </div>
        <UserMenu
          name={user.firstName}
          userId={user.id}
          isAdmin={user.isAdmin}
          pictureUrl={auth.data?.attributes?.picture}
          onLogout={() => logOut()}
        />
      </div>
    </nav>
  )
}

export default Header
